@if (session?.$resolved) {
  @if (session.$error) {
    <aside class="lv-learner-verify__sidebar">
      <div class="sidebar-branding"></div>
      <ul class="sidebar-checklist">
        <li class="is-error">
          <span translate>app.error</span>
        </li>
      </ul>
    </aside>

    <section class="lv-learner-verify__body">
      <lv-verify-token-error (dismiss)="close()" [session]="session"></lv-verify-token-error>
    </section>
  } @else {
    <aside class="lv-learner-verify__sidebar">
      <div class="sidebar-branding"></div>
      <ul class="sidebar-checklist">
        <li [ngClass]="classFor(1)">
          <span translate>learner-verify.component.instructions</span>
        </li>
        <li [ngClass]="classFor(2)">
          <span translate>learner-verify.component.system-test</span>
        </li>

        @if (session.requiresIdentification) {
          <li [ngClass]="classFor(3)">
            <span translate>learner-verify.component.user-photo</span>
          </li>

          <li [ngClass]="classFor(4)">
            <span translate>learner-verify.component.id-photo</span>
          </li>
        }

        @if (session.liveAgent) {
          <li [ngClass]="classFor(5)">
            <span translate>learner-verify.component.live-agent</span>
          </li>
        }

        @if (session.biometrics) {
          <li [ngClass]="classFor(6)">
            <span translate>learner-verify.component.biometrics</span>
          </li>
        }

        <li [ngClass]="classFor(7)">
          <span translate>learner-verify.component.ready</span>
        </li>
      </ul>
      @if (session.tokbox) {
        <lv-tokbox-view [tokbox]="session.tokbox" [connect]="connectLiveAgent"></lv-tokbox-view>
      }
      <button class="button is-secondary dismiss-btn" (click)="confirmDismiss()">
        <span class="icon">
          <i lvIcon="times"></i>
        </span>
        <span translate>app.close</span>
      </button>
    </aside>

    <section class="lv-learner-verify__body">
      @switch (step) {
        @case (1) {
          <lv-verify-instructions (next)="next()" [session]="session" [learner]="learner"></lv-verify-instructions>
        }
        @case (2) {
          <lv-verify-system (next)="next()" [session]="session"></lv-verify-system>
        }
        @case (3) {
          <lv-verify-photo
            (photoTaken)="onFacePhotoTaken($event)"
            (next)="next()"
            [session]="session"
            [channel]="channel"
          ></lv-verify-photo>
        }
        @case (4) {
          @if (session.requiresIdentification) {
            <lv-verify-id
              (photoTaken)="onIdPhotoTaken($event)"
              (next)="next()"
              (back)="back()"
              [session]="session"
              [sessionToken]="sessionToken"
              [channel]="channel"
            ></lv-verify-id>
          }
        }
        @case (5) {
          @if (session.liveAgent) {
            <lv-verify-agent [session]="session" [connect]="connectLiveAgent"></lv-verify-agent>
          }
        }
        @case (6) {
          @if (session.biometrics) {
            <lv-verify-biometrics
              [session]="session"
              [learner]="session.learner"
              (next)="next()"
              (back)="back()"
              (restart)="restart()"
            ></lv-verify-biometrics>
          }
        }
        @case (7) {
          <lv-verify-ready [session]="session" (next)="start()"></lv-verify-ready>
        }
      }
    </section>
  }
}
